import React from 'react';
import type { DerivedInvoiceStatus } from '../../../services/billing';
import { STATUS_LABELS } from './statusLabels';

// Doctor-facing status pill — markup/classes mirror files-viewer's
// billing/StatusBadge.tsx exactly (solid box, white text, soft leading dot),
// with a tone mapping adapted to our narrower derived vocabulary (upcoming/
// open/partial/paid/overdue/void). Where a key overlaps files-viewer's own
// (open/partial/paid/void), we reuse their exact hue; 'upcoming' takes their
// 'pending' gray, and 'overdue' takes their 'error' rose — the closest
// "needs attention" analog on a doctor-facing status set that has no
// internal error state.
interface Tone {
    bg: string;
    strike?: boolean;
}

const TONES: Record<DerivedInvoiceStatus, Tone> = {
    upcoming: { bg: 'bg-gray-500' },
    open: { bg: 'bg-teal-600' },
    partial: { bg: 'bg-amber-600' },
    paid: { bg: 'bg-emerald-600' },
    overdue: { bg: 'bg-rose-600' },
    void: { bg: 'bg-gray-400', strike: true }
};

interface StatusBadgeProps {
    status: DerivedInvoiceStatus;
    className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
    const tone = TONES[status];
    return (
        <span
            className={`inline-flex items-center max-w-[130px] gap-1.5 rounded-md px-2.5 py-1 text-[11px] font-semibold text-white ${tone.bg} ${className}`}
        >
            <span className="w-1.5 h-1.5 rounded-full bg-white/40 flex-shrink-0" />
            <span className={`truncate ${tone.strike ? 'line-through' : ''}`}>
                {STATUS_LABELS[status]}
            </span>
        </span>
    );
};
